import { graphql, useStaticQuery } from 'gatsby';
export const useEmployeeQuotes = () => {
    const query = useStaticQuery(graphql `
      query useEmployeeQuotes {
        cosmos {
          collections {
            employeeQuotes {
              name
              role
              quote
              image {
                ticket
              }
            }
          }
        }
      }
    `);
    return {
        employeeQuotes: query.cosmos.collections.employeeQuotes,
    };
};
export default useEmployeeQuotes;
